var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 10.0003C12.3018 10.0003 14.1673 8.13485 14.1673 5.83366C14.1673 3.53247 12.3018 1.66699 10.0007 1.66699C7.69946 1.66699 5.83398 3.53247 5.83398 5.83366C5.83398 8.13485 7.69946 10.0003 10.0007 10.0003Z",
    fill: "#007FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 12.083C5.82578 12.083 2.42578 14.883 2.42578 18.333C2.42578 18.5663 2.60911 18.7497 2.84245 18.7497H17.1591C17.3924 18.7497 17.5758 18.5663 17.5758 18.333C17.5758 14.883 14.1758 12.083 10.0008 12.083Z",
    fill: "#007FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e6b1ce0de9334c12fc7e1c4e913f7d85.svg";
export { ForwardRef as ReactComponent };